import React, {Component} from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'

import CardWrapper from '../../../../../components/Cards/CardWrapper/CardWrapper'
import SimpleLoader from '../../../../../components/Loaders/SimpleLoader'
import {ErrorMessage} from '../../../../../components/DisplayData/DisplayData'
import {RoundedButton} from '../../../../../components/Buttons/GeneralButtons'

import {formData} from './data'
import {contentData} from './content'
import LineInputText from '../../../../../components/Inputs/LineInputText/LineInputText';
import LineInputSelect from '../../../../../components/Inputs/LineInputSelect/LineInputSelect';
import ContentText from '../../../../../components/Texts/ContentText';
import ItemSelection from '../../../../../components/Inputs/ItemSelection/ItemSelection';

const styles = (theme) => ({
  root:{padding:'32px'},
  subtitle:{
    color:theme.palette.primary.main,
    fontWeight:'500'
  }
})



class AddHospitalCard extends Component {

  state = {
    form: JSON.parse(JSON.stringify(formData)),
    accredited:true,
    isValid:false
  }

  render(){

    const {classes, language, issending, error} = this.props
    const {form, isValid, accredited} = this.state
    const content = contentData[language]

    let tempForm = {...form}

    let loaderContent = null
    if(issending){
      loaderContent = <SimpleLoader />
    }else{
      if(error){
        loaderContent = <ErrorMessage message={error}/>
      }
    }    

    return(
      <CardWrapper>
        <div className={classes.root}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <ContentText text='Informacion del hospital' variant='bold' medium/>
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <LineInputText
                        data={tempForm.name}
                        onChange={this.onInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LineInputSelect
                        data={tempForm.hospital_value_id}
                        onChange={this.onInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LineInputText
                        data={tempForm.address}
                        onChange={this.onInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Grid container justifyContent='flex-end'>
                        <Grid item>
                          <ItemSelection 
                            id='accredited'
                            status={accredited}
                            text='Acreditado'
                            onChange={this.onChangeCheckbox}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LineInputText
                        data={tempForm.crm_id}
                        onChange={this.onInputChange}
                        
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LineInputText
                        data={tempForm.uci}
                        onChange={this.onInputChange}
                        
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
              {/************************** CONTACT ******************** */}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <ContentText text='Información de contacto' variant='bold' medium/>
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <LineInputText
                        data={tempForm.contact_name}
                        onChange={this.onInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LineInputText
                        data={tempForm.contact_email}
                        onChange={this.onInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LineInputText
                        data={tempForm.contact_phone}
                        onChange={this.onInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LineInputText
                        data={tempForm.contact_ext}
                        onChange={this.onInputChange}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container justifyContent='flex-end' alignItems='center' spacing={2}>
                <Grid item>
                  {loaderContent}
                </Grid>
                <Grid item>
                  <RoundedButton 
                    label={content.add_button} 
                    size='small' 
                    disabled={!isValid}
                    onClick={this.onSubmit}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </CardWrapper>
    )
  }

  componentDidMount(){
    const {language, catalogs} = this.props
    const {form} = this.state
    const content = contentData[language]
    let tempA = {...form}
    tempA.hospital_value_id.options = [...catalogs.hospital_values]
    Object.keys(form).forEach(item => {
      tempA[item].value = ''
      tempA[item].config = {...tempA[item].config,...content.form[item]}
    })
    this.setState({form:{...tempA}})
  }

  onInputChange = (data) => {
    const {form} = this.state
    const id = data.config.id;
    let temp = {...form};
    temp[id] = {...data};
    const isValidForm = this.validationForm(temp)
    this.setState({form:{...temp}, isValid:isValidForm})
  }

  validationForm = (data) => {
    let isValid = true;
    Object.keys(data).forEach((item) => {
      if(data[item].isRequired && !data[item].isValid){
        isValid = false;
      }
    })
    return isValid;
  }

  onSubmit = () => {
    const {onSubmit} = this.props
    const {form, accredited} = this.state
    let data2Send = {}
    
    Object.keys(form).forEach((item)=>{
      if(form[item].isValid){
        data2Send = {...data2Send, [item]:form[item].value}
      }
    })
    data2Send = {...data2Send, accredited: accredited ? 1 : 0}
    onSubmit(data2Send)
  }

  onChangeCheckbox = (id, status) => {
    if(!status){
      const {form} = this.state
      let temp = {...form}
      //temp[id].value = 6
      const isValidForm = this.validationForm(temp)
      this.setState({form:{...temp}, isValid:isValidForm})
    }
    this.setState({[id]:status})
  }
}

export default withStyles(styles)(AddHospitalCard)